import { Label } from '@uds/label';
import { cx } from 'linaria';
import { classNames } from '@uds/typography';
import './textarea.stylesheet_18n702l.css';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const textarea = {
  default: "d1oa80aa",
  disabled: "d1klsu2r",
  readOnly: "rwsf019",
  error: "ekjmof3"
};
const msgError = {
  default: "drwajw0"
};
const description = {
  default: "di75wm"
};
const getClassNames = _ref => {
  let {
    disabled,
    readOnly,
    error
  } = _ref;
  return {
    textarea: cx(classNames.content, textarea.default, disabled === true || readOnly === true ? textarea.disabled : null, readOnly === true ? textarea.readOnly : null, error === true ? textarea.error : null),
    error: cx(classNames.footnote, msgError.default),
    desc: cx(classNames.footnote, description.default)
  };
};

const Textarea = _ref => {
  let {
    rows = 4,
    onChange = () => null,
    ...props
  } = _ref;
  const {
    disabled,
    readOnly,
    error
  } = props;
  const hasError = error != null;
  const classNames = getClassNames({
    disabled,
    readOnly,
    error: hasError
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [props.label != null && /*#__PURE__*/jsx(Label, {
      hint: props.hint,
      htmlFor: props.id,
      children: props.label
    }), /*#__PURE__*/jsx("textarea", {
      className: classNames.textarea,
      rows: rows,
      onChange: onChange,
      ...props
    }), hasError && /*#__PURE__*/jsx("div", {
      className: classNames.error,
      children: error
    }), props.desc != null && /*#__PURE__*/jsx("div", {
      className: classNames.desc,
      children: props.desc
    })]
  });
};
var Textarea$1 = Textarea;

export { Textarea$1 as Textarea };
